import React, { useContext, useMemo } from "react";

//Highcharts
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsItemSeries from "highcharts/modules/item-series";

//Context
import DataHandling from "../../utils/dataHandling";
import {
  config_lineChartEV,
} from "../../models/diagramsConfig";
import { GetDataContext } from "../../context/GetDataContext";

//Highcharts Modules
HighchartsItemSeries(Highcharts);

const RegressionV2 = () => {
  //Data
  const {
    evData,
    appConfigOptions,
  } = useContext(GetDataContext);
  //Filtering
  const filter = {value: 0, label: 'ΟΛΕΣ ΟΙ ΕΤΑΙΡΙΕΣ'}; // Hard coded filter object with zero because we need all companies

  useMemo(() => {
    if (evData.data.length > 0) {
        DataHandling(evData, filter, appConfigOptions)
    }
  }, [ evData, appConfigOptions]);

  return (
    <div className="regression">
      <header className="widget-header--politics">
        <a className="politics__header" href="/pollitics/">
          <svg xmlns="http://www.w3.org/2000/svg" width="276" height="70" viewBox="0 0 276 70">
            <g id="Group_3052" data-name="Group 3052" transform="translate(262.099 -2424.874)">
              <path id="Path_2036" data-name="Path 2036" d="M-262.1,2426.817h17.045c5.368,0,9.8,1.115,12.973,3.791,3.176,2.722,4.966,7.05,4.966,13.474v12.046c0,6.737-1.745,11.109-4.876,13.875s-7.6,3.837-12.973,3.837h-2.64v20.879H-262.1Zm16.865,33.059c2.729,0,3.579-1.2,3.579-3.748v-12.046c0-2.1-.85-3.167-3.4-3.167h-2.55v18.961Z" transform="translate(0 -0.872)"/>
              <path id="Path_2037" data-name="Path 2037" d="M-186.257,2489.832c-2.774-3.212-3.892-7.763-3.892-13.161v-33.64c0-5.353,1.118-9.9,3.892-13.116s7.113-5.041,13.734-5.041,11.005,1.829,13.779,5.041,3.847,7.763,3.847,13.161v33.639c0,5.353-1.074,9.9-3.847,13.116s-7.158,5.042-13.779,5.042S-183.483,2493.044-186.257,2489.832Zm16.329-10.529a6.112,6.112,0,0,0,.537-2.587v-33.639a5.783,5.783,0,0,0-.537-2.632,2.767,2.767,0,0,0-2.595-1.472c-.089,0-.134,0-.179-.044a2.668,2.668,0,0,0-2.416,1.517,6.114,6.114,0,0,0-.537,2.587v33.64a5.868,5.868,0,0,0,.582,2.632,2.607,2.607,0,0,0,2.55,1.473h.09c0,.044,0,.044.045.044A2.74,2.74,0,0,0-169.928,2479.3Z" transform="translate(-32.234 0)"/>
              <path id="Path_2038" data-name="Path 2038" d="M-116.376,2426.817h14.494v54.027h15.836v13.875h-30.331Z" transform="translate(-65.284 -0.872)"/>
              <path id="Path_2039" data-name="Path 2039" d="M-53.908,2426.817h14.494v54.027h15.837v13.875H-53.908Z" transform="translate(-93.27 -0.872)"/>
              <path id="Path_2040" data-name="Path 2040" d="M10.1,2426.978h5.145v67.813H10.1Z" transform="translate(-121.946 -0.944)"/>
              <path id="Path_2041" data-name="Path 2041" d="M42.985,2431.923H30.458v-4.863h30.2v4.863H48.129v62.906H42.985Z" transform="translate(-131.066 -0.981)"/>
              <path id="Path_2042" data-name="Path 2042" d="M96.34,2426.978h5.145v67.813H96.34Z" transform="translate(-160.581 -0.944)"/>
              <path id="Path_2043" data-name="Path 2043" d="M125.06,2491.756a14.1,14.1,0,0,1-4.071-7.718,44.045,44.045,0,0,1-.805-9.459v-28.508a42.7,42.7,0,0,1,.85-9.636,13.746,13.746,0,0,1,4.116-7.629c2.147-1.919,5.324-3.124,9.8-3.124h.045c4.518,0,7.739,1.249,9.931,3.168a14.009,14.009,0,0,1,4.071,7.362,37.348,37.348,0,0,1,.805,8.521v1.294H144.61v-1.294c0-3.792-.224-7.451-1.566-10.038s-3.757-4.238-8.052-4.238c-4.34,0-6.711,1.7-8.053,4.506-1.342,2.855-1.611,6.737-1.611,11.2v28.331a46.54,46.54,0,0,0,.492,7.762,10.026,10.026,0,0,0,2.639,5.666c1.431,1.384,3.49,2.187,6.532,2.187,4.116,0,6.487-1.562,7.918-4.105,1.387-2.543,1.7-6.111,1.7-10.171v-1.295H149.8v1.339a35.207,35.207,0,0,1-.895,8.61,13.972,13.972,0,0,1-4.16,7.361c-2.192,1.918-5.324,3.078-9.752,3.078C130.473,2494.924,127.252,2493.72,125.06,2491.756Z" transform="translate(-171.263 -0.363)"/>
              <path id="Path_2044" data-name="Path 2044" d="M187.034,2489.838c-2.058-3.167-2.46-7.585-2.46-12.625v-2.677h5.055v2.365c0,4.506.358,7.807,1.79,9.949,1.387,2.186,3.758,3.257,7.873,3.257,3.579,0,5.995-1.339,7.471-3.569s2.058-5.354,2.058-8.924v-.49a15.761,15.761,0,0,0-1.879-8.164,15.136,15.136,0,0,0-5.726-5.219l-6.576-3.793a19.057,19.057,0,0,1-7.381-6.871c-1.566-2.721-2.237-6.111-2.237-10.618v-.8c0-10.038,4.921-15.972,14.45-15.972,5.145,0,8.723,1.7,11.049,4.551,2.326,2.9,3.356,6.96,3.356,11.778v4.016h-5.145l-.09-5.4a11.944,11.944,0,0,0-2.237-7.183,8.5,8.5,0,0,0-6.979-2.989c-3.534,0-5.9,1.428-7.337,3.614a14.229,14.229,0,0,0-1.924,8.477l.045,1.606c.179,5.131,3.265,9.012,7.739,11.555l6.487,3.658a18.709,18.709,0,0,1,7.158,7.049,22.468,22.468,0,0,1,2.416,10.172v.892c0,5.4-1.029,9.771-3.356,12.759-2.371,3.035-6.084,4.685-11.318,4.685C192.716,2494.924,189.092,2493.05,187.034,2489.838Z" transform="translate(-200.109 -0.363)"/>
            </g>
          </svg>
        </a>
        <h2 className="politics__description">Οι εκλογικές τάσεις όπως αποτυπώνονται <br/> στο σύνολο των ερευνών</h2>
      </header>
      <section className={"container container-evaluation"}>
        <HighchartsReact
          highcharts={Highcharts}
          options={config_lineChartEV}
          updateArgs={[true, true, true]}
        />
      </section>
        <div className="politics__infos">
          <span>*Η εκτίμηση ψήφου προκύπτει από την τελευταία μέση τιμή όλων των δημοσκοπήσεων</span>
        </div>
        <div className="politics__footer">
          <a className="politics__button" href="/pollitics/" target="_self">
            <span>ΠΕΡΙΣΣΟΤΕΡΑ ΑΡΘΡΑ</span>
              <svg xmlns="http://www.w3.org/2000/svg" id="red_arrow" width="16" height="16" viewBox="0 0 16 16">
              <rect id="Rectangle_5612" data-name="Rectangle 5612" width="16" height="16" fill="none"/>
              <path id="red_arrow-2" data-name="red_arrow" d="M12.208,16.36,10.8,14.952,17.072,8.68,10.8,2.408,12.208,1l7.68,7.68Z" transform="translate(-7.344 -0.68)"/>
              </svg>
          </a>
        </div>
    </div>
  );
};

export default RegressionV2;
